import { createApp, reactive } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import IndexView from '../pages/public_profile/designer_collection/Index.vue';
import NewView from '../pages/public_profile/designer_collection/New.vue';
import ShowView from '../pages/public_profile/designer_collection/Show.vue';
import EditView from '../pages/public_profile/designer_collection/Edit.vue';
import SortingView from '../pages/public_profile/designer_collection/Sorting.vue';

import BaseCollectionForm from '../pages/public_profile/designer_collection/BaseCollectionForm.vue';

import DesignerCollectionItem from "../components/DesignerCollectionItem.vue";
import CollectionSortItem from "../components/CollectionSortItem.vue";
import PostSortItem from "../components/PostSortItem.vue";
import SortedActionButtons from "../components/SortedActionButtons.vue";
import PostItem from "../components/PostItem.vue";
import SearchInput from '../components/SearchInput.vue';

class PublicProfileDesignerCollectionComponent {
  constructor({ container, props = {} }) {
    this.app = null;
    this.container = container;
    this.props = props;
  }

  // 取得對應的 vue component
  getViewComponent() {
    const views = {
      'index': IndexView,
      'new': NewView,
      'edit': EditView,
      'show': ShowView,
      'sorting': SortingView,
    };
    return views[this.props.view];
  }

  init() {
    try {
      const ViewComponent = this.getViewComponent();

      if (!ViewComponent) {
        console.error(`View '${this.view}' not found`);
        return;
      }

      this.app = createApp(ViewComponent, this.props);
      this.app.use(I18NextVue, { i18next });
      this.app.use(VueLazyload, {
        preLoad: 2.6
      });

      this.app.component('post-sort-item', PostSortItem);
      this.app.component('sorted-action-buttons', SortedActionButtons);
      this.app.component('base-collection-form', BaseCollectionForm);
      this.app.component('designer-collection-item', DesignerCollectionItem);
      this.app.component('collection-sort-item', CollectionSortItem);
      this.app.component('post-item', PostItem);
      this.app.component('search-input', SearchInput);

      this.app.config.errorHandler = (err, vm, info) => {
        console.error('Vue Error:', err);
        console.error('Error Info:', info);
      };

      this.app.mount(this.container);
    } catch (error) {
      console.error('Component initialization error:', error);
    }
  }
}

export default PublicProfileDesignerCollectionComponent;
